export const appConfig = {
    maintenance: {
        start: new Date(Date.UTC(2021, 4, 19, 20)),
        end: new Date(Date.UTC(2021, 4, 20, 4)),
        title: 'ui.maintenance.title',
        description: 'ui.maintenance.description'
    }
};
